import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue";
import _imports_0 from '@/assets/images/boosted-apy.png';
const _hoisted_1 = { class: "flex flex-wrap justify-between items-center pt-1.5 md:pt-5" };
const _hoisted_2 = { class: "pr-1.5 leading-11/10 md:w-[144px] title-italic" };
const _hoisted_3 = { class: "text-[1.25rem] md:text-h3" };
const _hoisted_4 = { class: "py-px text-xs leading-10/10 opacity-40 md:py-0.5 md:text-sm" };
const _hoisted_5 = { class: "grid order-last grid-cols-3 pt-2.5 space-x-1.5 w-full border-t border-dark/20 border-solid md:flex md:order-none md:grid-cols-none md:p-0 md:w-auto md:border-none" };
const _hoisted_6 = { class: "flex md:w-[110px]" };
const _hoisted_7 = { class: "inline-block md:block" };
const _hoisted_8 = { class: "flex items-center mb-0.5" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("div", { class: "text-[0.6875rem] leading-9/10 title" }, "tvl", -1);
const _hoisted_10 = { class: "flex justify-center items-center ml-1 w-2.5 h-2.5 text-[0.5rem] font-bold text-dark rounded-full border border-dark opacity-50" };
const _hoisted_11 = /*#__PURE__*/ _createTextVNode(" i ");
const _hoisted_12 = [
    _hoisted_11
];
const _hoisted_13 = {
    key: 0,
    class: "text-[1.75rem] leading-none title-italic"
};
const _hoisted_14 = {
    key: 0,
    class: "text-h4"
};
const _hoisted_15 = {
    key: 1,
    class: "text-h4"
};
const _hoisted_16 = { class: "flex md:w-[70px]" };
const _hoisted_17 = { class: "inline-block md:block" };
const _hoisted_18 = { class: "flex items-center mb-0.5" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("div", { class: "text-[0.6875rem] leading-9/10 title" }, "apy", -1);
const _hoisted_20 = { class: "flex justify-center items-center ml-1 w-2.5 h-2.5 text-[0.5rem] font-bold text-dark rounded-full border border-dark opacity-50" };
const _hoisted_21 = /*#__PURE__*/ _createTextVNode(" i ");
const _hoisted_22 = [
    _hoisted_21
];
const _hoisted_23 = {
    key: 0,
    class: "flex text-[1.75rem] leading-none title-italic"
};
const _hoisted_24 = { key: 0 };
const _hoisted_25 = { key: 1 };
const _hoisted_26 = { class: "flex md:w-[94px]" };
const _hoisted_27 = {
    key: 0,
    class: "inline-block md:block"
};
const _hoisted_28 = { class: "flex items-center mb-0.5" };
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("div", { class: "text-[0.6875rem] leading-9/10 title" }, "boosted apy", -1);
const _hoisted_30 = { class: "flex justify-center items-center ml-1 w-2.5 h-2.5 text-[0.5rem] font-bold text-dark rounded-full border border-dark opacity-50" };
const _hoisted_31 = /*#__PURE__*/ _createTextVNode(" i ");
const _hoisted_32 = [
    _hoisted_31
];
const _hoisted_33 = {
    key: 0,
    class: "flex text-[1.75rem] leading-none title-italic"
};
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    class: "mt-0.5 mr-1 h-[26px]",
    alt: "boosted apy"
}, null, -1);
const _hoisted_35 = { class: "flex items-center py-2.5 md:py-0" };
const _hoisted_36 = ["disabled"];
const _hoisted_37 = { key: 0 };
const _hoisted_38 = {
    key: 2,
    class: "leading-9/10"
};
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("span", { class: "text-base leading-10/10" }, "deposit", -1);
const _hoisted_40 = {
    key: 3,
    class: "text-sm leading-9/10"
};
const _hoisted_41 = /*#__PURE__*/ _createTextVNode("Change ");
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_43 = /*#__PURE__*/ _createTextVNode(" network");
const _hoisted_44 = [
    _hoisted_41,
    _hoisted_42,
    _hoisted_43
];
const _hoisted_45 = { key: 4 };
const _hoisted_46 = {
    key: 0,
    class: "my-2.5 h-px bg-dark/20"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SpinnerMini = _resolveComponent("SpinnerMini");
    const _component_listOfTokens = _resolveComponent("listOfTokens");
    const _directive_tippy = _resolveDirective("tippy");
    return (_ctx.strategy)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["px-5 rounded-small transition-colors", _ctx.customClass])
        }, [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.strategy.title), 1),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.vaultName), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _hoisted_9,
                                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12)), [
                                    [_directive_tippy, _ctx.tippy.TVLDesktop]
                                ])
                            ]),
                            (_ctx.strategy.dataLoaded.tvl)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    (_ctx.strategy.formatted.tvl.value)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("span", null, "$" + _toDisplayString(_ctx.strategy.formatted.tvl.separately.firstNum), 1),
                                            (_ctx.strategy.formatted.tvl.separately.secondNum)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "." + _toDisplayString(_ctx.strategy.formatted.tvl.separately.secondNum), 1))
                                                : _createCommentVNode("", true),
                                            (_ctx.strategy.formatted.tvl.symbol)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.strategy.formatted.tvl.symbol), 1))
                                                : _createCommentVNode("", true)
                                        ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode("$" + _toDisplayString(_ctx.strategy.formatted.tvl), 1)
                                        ], 64))
                                ]))
                                : (_openBlock(), _createBlock(_component_SpinnerMini, {
                                    key: 1,
                                    class: "mt-1.5 w-6 h-6 text-dark"
                                }))
                        ])), [
                            [_directive_tippy, _ctx.tippy.TVLMobile]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                                _hoisted_19,
                                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22)), [
                                    [_directive_tippy, _ctx.tippy.APYDesktop]
                                ])
                            ]),
                            (_ctx.strategy.dataLoaded.apy || _ctx.strategy.disableAPY)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    (_ctx.strategy.disableAPY)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, "0%"))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.strategy.formatted.apy) + "%", 1))
                                ]))
                                : (_openBlock(), _createBlock(_component_SpinnerMini, {
                                    key: 1,
                                    class: "mt-1.5 w-6 h-6 text-dark"
                                }))
                        ])), [
                            [_directive_tippy, _ctx.tippy.APYMobile]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                        (_ctx.strategy.showBoostBtn && !_ctx.strategy.disableAPY)
                            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                    _hoisted_29,
                                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32)), [
                                        [_directive_tippy, _ctx.tippy.boostAPYDesktop]
                                    ])
                                ]),
                                (_ctx.strategy.dataLoaded.maxBoosting)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                        _hoisted_34,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.maxBoostingWithoutDecimals) + "%", 1)
                                    ]))
                                    : (_openBlock(), _createBlock(_component_SpinnerMini, {
                                        key: 1,
                                        class: "mt-1.5 w-6 h-6 text-dark"
                                    }))
                            ])), [
                                [_directive_tippy, _ctx.tippy.boostAPYMobile]
                            ])
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", {
                        class: "flex justify-center items-center mr-4 w-5 h-5 text-base text-dark rounded-full border border-dark cursor-pointer",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('openInfo')))
                    }, " i "),
                    _createElementVNode("button", {
                        class: _normalizeClass(["flex justify-center items-center w-[90px] h-[35px] text-base tracking-tight leading-10/10 text-white bg-dark rounded-[0.3125rem] md:w-[110px] md:h-[40px] md:text-h4 title-italic btn-prop", {
                                'hover:scale-95 active:scale-90': !_ctx.strategy.disableAPY && !_ctx.strategy.isBtnProgress,
                            }]),
                        disabled: _ctx.strategy.isBtnProgress ||
                            (!_ctx.strategy.dataLoaded.apy && !_ctx.strategy.dataLoaded.apy) ||
                            _ctx.strategy.disableAPY,
                        onClick: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.open && _ctx.open(...args)))
                    }, [
                        (_ctx.strategy.disableAPY)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Deposit"))
                            : (_ctx.strategy.isBtnProgress)
                                ? (_openBlock(), _createBlock(_component_SpinnerMini, { key: 1 }))
                                : (_ctx.isCrossChainStatus)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["block text-[0.6875rem] leading-9/10", _ctx.textClass])
                                        }, "CrossChain", 2),
                                        _hoisted_39
                                    ]))
                                    : (_ctx.isDisabledStatus)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, _hoisted_44))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_45, "Deposit"))
                    ], 10, _hoisted_36)
                ])
            ]),
            (_ctx.strategy.listOfTokens.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46))
                : _createCommentVNode("", true),
            _createVNode(_component_listOfTokens, {
                list: _ctx.strategy.listOfTokens,
                "text-class": _ctx.textClass,
                "is-loading": _ctx.strategy.isCurrencyLoaded,
                "is-blocking": !_ctx.strategy.dataLoaded.apy || _ctx.strategy.isBtnProgress || _ctx.strategy.disableAPY,
                onSelected: _ctx.setSelectedCurrency
            }, null, 8, ["list", "text-class", "is-loading", "is-blocking", "onSelected"])
        ], 2))
        : _createCommentVNode("", true);
}
